import {useOrganManagerShareGetter} from "./hooks/useOrganManagerShareGetter";
import {ListTable} from "../../../layout/content/list/ListTable";
import {ListCount, WhichList} from "../../../components/ListCount";
import React, {useEffect, useState} from "react";
import {useOrganManagerShareFilters} from "./hooks/useOrganManagerShareFilters";
import {useOrganManagerShareColumns} from "./hooks/useOrganManagerShareColumns";
import {DetailActionButton} from "../../../components/Buttons";
import counselorAddImg from "../../../assets/images/button_icons/person-add-icon.png"
import {useOrganManagerShareActions} from "./hooks/useOrganManagerShareActions";
import {OrganShareAllocateDTO} from "../../../types/organShare";

export function OrganManagerShareList() {
    const {
        organShareManagerList,
        pageCondition,
        totalCount,
        searchOrganManagerShareList,
    } = useOrganManagerShareGetter();

    const [organIdx, setOrganIdx] = useState<number[]>([])
    const [selectedManagerIdx, setSelectedManagerIdx] = useState<number[]>([])
    const {filters} = useOrganManagerShareFilters({search : searchOrganManagerShareList({})});
    const {columns} = useOrganManagerShareColumns();
    const {allocateAuthority} = useOrganManagerShareActions();

    useEffect(() => { // 소속 정보 로컬스토리지에 임시 저장
        const urlParams = new URLSearchParams(window.location.search);
        const targetOrganList = urlParams.getAll('targetOrganList').map(Number);

        if (targetOrganList.length > 0) {
            setOrganIdx(targetOrganList);
            localStorage.setItem('selectedOrganList', JSON.stringify(targetOrganList));
        } else {
            const saved = localStorage.getItem('selectedOrganList');
            if (saved) {
                setOrganIdx(JSON.parse(saved));
            }
        }
    }, []);

    const onClickOrganShare = () => {
        if (selectedManagerIdx.length === 0) {
            alert("공유 받을 관리자를 선택해주세요.");
            return;
        }

        if (window.confirm("선택하신 소속을 공유하시겠습니까?")) {
            const dto:OrganShareAllocateDTO ={
                organList: organIdx,
                organManagerList: selectedManagerIdx
            }
            allocateAuthority(dto).then();
        }
    }
    return(
        <>
            {organShareManagerList && (
                <ListTable
                    filters={filters}
                    buttonsNode={
                        <>
                            <div />
                            <div>
                                <DetailActionButton onClick={() => onClickOrganShare()}>
                                    <img src={counselorAddImg} alt={"소속 공유"}/>
                                    &nbsp;소속 공유
                                </DetailActionButton>
                            </div>
                        </>
                    }
                    listData={organShareManagerList}
                    checkedRowIdxArr={selectedManagerIdx}
                    setCheckedRowIdxArr={setSelectedManagerIdx}
                    getList={({page, sort, size}) => searchOrganManagerShareList({page, sort, size})}
                    columns={columns}
                    showCheckbox={() => true}
                    totalRowsCnt={{
                        totalCount: <ListCount totalCount={totalCount ?? 0}
                                               whichList={WhichList.ORGAN_MANAGER}/>,
                        singleUnitKeyInCommonFile: "codeUnit.singleComponent",
                        multipleUnitKeyInCommonFile: "codeUnit.multipleComponent",
                    }}
                    pageOnFilter={pageCondition}
                />
            )}
        </>
    )
}